// src/components/webinar_funnel/sections/SourceSummary.jsx
import React, { useMemo } from 'react';
import { useSourceSummaryFilters } from '../../../../hooks/useFilters';
import FilterControls from './FilterControls';
import FunnelChart from '../../charts/FunnelChart';

// ─── Main component ───────────────────────────────────────────────────────────
const SourceSummary = ({ data, onCardClick }) => {
  const filters = useSourceSummaryFilters(data);

  const stats = useMemo(() => {
    if (!filters.filteredData.length) return null;

    const t = filters.filteredData.reduce(
      (acc, item) => ({
        campaigns:     acc.campaigns     + 1,
        invitations:   acc.invitations   + (item.invitations || 0),
        registrations: acc.registrations + (item.registrations?.total || 0),
        attendees:     acc.attendees     + (item.attendees?.total || 0),
        bookings:      acc.bookings      + (item.bookings?.total || 0),
        shows:         acc.shows         + (item.sales?.show || 0),
        sales:         acc.sales         + (item.sales?.total || 0),
        revenue:       acc.revenue       + (item.sales?.revenue || 0),
      }),
      { campaigns:0, invitations:0, registrations:0, attendees:0, bookings:0, shows:0, sales:0, revenue:0 },
    );

    return {
      ...t,
      inviteToReg:    t.invitations   > 0 ? ((t.registrations / t.invitations)   * 100).toFixed(1) : '0',
      regToAttend:    t.registrations > 0 ? ((t.attendees     / t.registrations) * 100).toFixed(1) : '0',
      attendToBook:   t.attendees     > 0 ? ((t.bookings      / t.attendees)     * 100).toFixed(1) : '0',
      bookedToShow:   t.bookings      > 0 ? ((t.shows         / t.bookings)      * 100).toFixed(1) : '0',
      showToSale:     t.shows         > 0 ? ((t.sales         / t.shows)         * 100).toFixed(1) : '0',
    };
  }, [filters.filteredData]);

  const fmt = (n) => Number(n).toLocaleString();
  const funnelStages = stats ? [
    { label: 'Invites',       value: fmt(stats.invitations),   rawValue: stats.invitations,   trend: '0.0',   metricKey: 'invitations',   chartType: 'bar', color: 'darkblue' },
    { label: 'Registrations', value: fmt(stats.registrations), rawValue: stats.registrations, trend: '16.1',  metricKey: 'registrations', chartType: 'bar', color: 'violet' },
    { label: 'Attendees',     value: fmt(stats.attendees),     rawValue: stats.attendees,     trend: '-0.2',  metricKey: 'attendees',     chartType: 'bar', color: 'teal' },
    { label: 'Calls Booked',  value: fmt(stats.bookings),      rawValue: stats.bookings,      trend: '-32.6', metricKey: 'bookings',      chartType: 'bar', color: 'brand' },
    { label: 'Calls Show',    value: fmt(stats.shows),         rawValue: stats.shows,         trend: 'N/A',   metricKey: 'show',          chartType: 'bar', color: 'brightblue' },
    { label: 'Sales',         value: fmt(stats.sales),         rawValue: stats.sales,         trend: 'N/A',   metricKey: 'sales',         chartType: 'bar', color: 'pink' },
  ] : [];

  return (
    <div className="space-y-4">
      <FilterControls {...filters} data={data} />

      {stats ? (
        <FunnelChart
          stages={funnelStages}
          onStageClick={onCardClick
            ? (stage) => onCardClick(stage.label, stage.value, filters.filteredData, stage.metricKey, stage.chartType, stage.color)
            : undefined
          }
        />
      ) : (
        <div className="py-8 text-center text-sm text-grey-400">
          No data matches the current filter.
        </div>
      )}
    </div>
  );
};

export default SourceSummary;